// src/components/question/ReportErrorModal.tsx

import React, { useState } from 'react';
import { X, AlertTriangle, Send } from 'lucide-react';
import { questionService } from '../../services/questionService';
import './ReportErrorModal.css';

interface ReportErrorModalProps {
    questionId: string;
    onClose: () => void;
    onShowToast: (message: string, type: 'success' | 'error' | 'info') => void;
}

const ReportErrorModal: React.FC<ReportErrorModalProps> = ({
    questionId,
    onClose,
    onShowToast
}) => {
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!description.trim()) {
            onShowToast('Descreva o erro encontrado', 'error');
            return;
        }
        if (description.trim().length < 10) {
            onShowToast('Descrição muito curta', 'error');
            return;
        }
        try {
            setLoading(true);
            await questionService.reportQuestionError(questionId, description.trim());
            onShowToast('Erro reportado com sucesso', 'success');
            onClose();
        } catch {
            onShowToast('Erro ao enviar reporte', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="rem-overlay" onClick={onClose}>
            <div className="rem-modal" onClick={e => e.stopPropagation()}>

                <div className="rem-header">
                    <div className="rem-header-left">
                        <AlertTriangle size={18} className="rem-header-icon" />
                        <span className="rem-header-title">Reportar erro na questão</span>
                    </div>
                    <button className="rem-close" onClick={onClose} disabled={loading}>
                        <X size={18} />
                    </button>
                </div>

                <div className="rem-body">
                    <p className="rem-hint">
                        Descreva o problema encontrado nesta questão. Sua contribuição ajuda a melhorar o conteúdo.
                    </p>
                    <textarea
                        className="rem-textarea"
                        placeholder="Ex: O enunciado está incompleto, a alternativa correta está errada, imagem não carrega..."
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                        rows={5}
                        maxLength={1000}
                        disabled={loading}
                        autoFocus
                    />
                    <span className="rem-counter">{description.length}/1000</span>
                </div>

                <div className="rem-footer">
                    <button
                        className="rem-btn-cancel"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancelar
                    </button>
                    <button
                        className="rem-btn-submit"
                        onClick={handleSubmit}
                        disabled={loading || !description.trim()}
                    >
                        {loading ? (
                            <span className="rem-spinner" />
                        ) : (
                            <Send size={14} />
                        )}
                        {loading ? 'Enviando...' : 'Enviar reporte'}
                    </button>
                </div>

            </div>
        </div>
    );
};

export default ReportErrorModal;